__turbopack_context__.v({
  "align-center": "Y6YhiW_align-center",
  "align-end": "Y6YhiW_align-end",
  "align-start": "Y6YhiW_align-start",
  "gap-lg": "Y6YhiW_gap-lg",
  "gap-md": "Y6YhiW_gap-md",
  "gap-sm": "Y6YhiW_gap-sm",
  "gap-xl": "Y6YhiW_gap-xl",
  "gap-xxl": "Y6YhiW_gap-xxl",
  "group": "Y6YhiW_group",
  "justify-around": "Y6YhiW_justify-around",
  "justify-between": "Y6YhiW_justify-between",
  "justify-center": "Y6YhiW_justify-center",
  "justify-end": "Y6YhiW_justify-end",
  "justify-start": "Y6YhiW_justify-start",
  "mb-lg": "Y6YhiW_mb-lg",
  "mb-md": "Y6YhiW_mb-md",
  "mb-sm": "Y6YhiW_mb-sm",
  "mb-xl": "Y6YhiW_mb-xl",
  "mb-xxl": "Y6YhiW_mb-xxl",
  "ml-lg": "Y6YhiW_ml-lg",
  "ml-md": "Y6YhiW_ml-md",
  "ml-sm": "Y6YhiW_ml-sm",
  "ml-xl": "Y6YhiW_ml-xl",
  "ml-xxl": "Y6YhiW_ml-xxl",
  "mr-lg": "Y6YhiW_mr-lg",
  "mr-md": "Y6YhiW_mr-md",
  "mr-sm": "Y6YhiW_mr-sm",
  "mr-xl": "Y6YhiW_mr-xl",
  "mr-xxl": "Y6YhiW_mr-xxl",
  "mt-lg": "Y6YhiW_mt-lg",
  "mt-md": "Y6YhiW_mt-md",
  "mt-sm": "Y6YhiW_mt-sm",
  "mt-xl": "Y6YhiW_mt-xl",
  "mt-xxl": "Y6YhiW_mt-xxl",
  "mx-lg": "Y6YhiW_mx-lg",
  "mx-md": "Y6YhiW_mx-md",
  "mx-sm": "Y6YhiW_mx-sm",
  "mx-xl": "Y6YhiW_mx-xl",
  "mx-xxl": "Y6YhiW_mx-xxl",
  "my-lg": "Y6YhiW_my-lg",
  "my-md": "Y6YhiW_my-md",
  "my-sm": "Y6YhiW_my-sm",
  "my-xl": "Y6YhiW_my-xl",
  "my-xxl": "Y6YhiW_my-xxl",
  "shimmer": "Y6YhiW_shimmer",
  "text-bar-sweep": "Y6YhiW_text-bar-sweep",
});
